import defaultClient from '@src/api/clients/default';

export function fetchLanes(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/',
    method: 'GET',
    payload: params,
  });
}

export function rebuildLanes(payload) {
  return defaultClient.request({
    url: 'dashboard/lanes/rebuild/',
    method: 'POST',
    payload,
  });
}

export function simulateLanes(payload) {
  return defaultClient.request({
    url: 'dashboard/lanes/simulate/',
    method: 'POST',
    payload,
  });
}

export function createLane(payload) {
  return defaultClient.request({
    url: 'dashboard/lanes/create/',
    method: 'POST',
    payload,
  });
}

export function updateLaneAssignment(id, payload) {
  return defaultClient.request({
    url: `dashboard/lane-assignments/${id}/`,
    method: 'PATCH',
    payload,
  });
}

export function updateLane(id, payload) {
  return defaultClient.request({
    url: `dashboard/lanes/${id}/`,
    method: 'PATCH',
    payload,
  });
}

export function deleteLane(id) {
  return defaultClient.request({
    url: `dashboard/lanes/${id}/`,
    method: 'DELETE',
  });
}

export function fetchLaneConflicts(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/conflicts/',
    method: 'GET',
    payload: params,
  });
}

export function fetchLaneRuns(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/runs/',
    method: 'GET',
    payload: params,
  });
}

export function bulkLockLane(laneId, locked) {
  return defaultClient.request({
    url: `dashboard/lanes/${laneId}/bulk-lock/`,
    method: 'POST',
    payload: { locked },
  });
}

export function fetchLaneMap(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/map/',
    method: 'GET',
    payload: params,
  });
}

export function fetchLaneSweep(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/sweep/',
    method: 'GET',
    payload: params,
  });
}

export function revertLanes(payload) {
  return defaultClient.request({
    url: 'dashboard/lanes/revert/',
    method: 'POST',
    payload,
  });
}

export function fetchLanesExport(params = {}) {
  return defaultClient.request({
    url: 'dashboard/lanes/export/',
    method: 'GET',
    payload: params,
    options: { responseType: 'blob' },
  });
}
